<template>
  <v-row dense class="body-1">
    <v-col cols="12" sm="5">
      Frete
    </v-col>
    <v-col cols="12" sm="7" class="text-right font-weight-bold">
      {{ item.frete | currency }}
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
